import { Fragment, useContext, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon, EyeSlashIcon } from "@heroicons/react/20/solid";
import { AuthContext } from "../../../contexts/AuthContext";
import { POST, PUT } from "../../../api/requests";
import { classNames } from "../../../utils/functions";
import { TeamContext } from "../../../contexts/TeamContext";
import { toast } from "react-toastify";

const roleMap = { member: "Member", owner: "Owner" };
const ROLES = {
  inbox: [
    { name: "Member", role: "member" },
    { name: "Admin", role: "admin" },
  ],

  organization: [
    { name: "Member", role: "member" },
    { name: "Admin", role: "admin" },
  ],
};
export default function RoleDropdown({
  disabled,
  uid,
  role,
  resourceType,
  resourceId,
}) {
  const [currentRole, setCurrentRole] = useState(role);
  const { team } = useContext(TeamContext);

  const updateUserRole = async (uid, newRole) => {
    setCurrentRole(newRole);
    let path;
    // Construct path based on resource type we are adjusting this role on
    if (resourceType && resourceId) {
      path = `/organizations/${team.id}/${resourceType}/${resourceId}/users/${uid}/roles`;
      // Otherwise this is an organization toggle
      // TODO: This is a really dumb pattern
    } else {
      path = `/organizations/${team.id}/users/${uid}/roles`;
    }
    const response = await PUT(path, { role: newRole.role });
    toast(`User role updated to ${newRole.role}`);
  };

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button
          disabled={disabled || currentRole == "owner"}
          className={`inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 ${
            disabled || currentRole == "owner" ? "opacity-50" : ""
          }`}
        >
          {roleMap[currentRole] || (
            <div className="flex items-center space-x-2">
              <EyeSlashIcon className="w-3 text-gray-600" />
              <p>No access</p>
            </div>
          )}
          {!disabled && currentRole != "owner" && (
            <ChevronDownIcon
              className="-mr-1 h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          )}
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {ROLES[resourceType || "organization"].map((role) => (
              <Menu.Item>
                {({ active }) => (
                  <a
                    href="#"
                    className={classNames(
                      active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                      "block px-4 py-2 text-sm"
                    )}
                    onClick={() => updateUserRole(uid, role)}
                  >
                    {role.name}
                  </a>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
